<template>
    <div 
        class="flow-item-stack" 
        :class="{
            'flow-item-stack-center': justify == 'center',
            'flow-item-stack-left': justify == 'left',
            'flow-item-stack-right': justify == 'right'
        }">

        <div 
            v-for="(asset, index) in visibleAssets" 
            :key="index" 
            class="flow-item-stack-frame">
            <AssetItem 
                :asset="asset" 
                :context="true" 
                :overflow="!isInputAsset(asset)"
                @select="handleSelect" />
        </div>
        
        <div v-if="remainingAssets.length > 0" class="flow-item-stack-frame">
            <FlowItemGallery 
                :assets="remainingAssets" 
                :lighter="lighter"
                @select="handleSelect" />
        </div>

        <div 
            v-if="isEmpty" 
            class="flow-item-stack-fill">
            no&nbsp;{{ label }}
        </div>

    </div>
</template>

<script>
import { mapGetters } from '@generio-ai/library-legacy/plugins/vuex'
import { isMobileDevice, isMobileResolution } from '@/utils/device'
import AssetItem from '@/components/common/asset/AssetItem.vue'
import FlowItemGallery from '@/components/library/flow/FlowItemGallery.vue'

    export default {
        name: 'FlowItemStack',
        components: {
            AssetItem,
            FlowItemGallery
        },
        props: {
            assets: {
                type: Array,
                default: []
            },
            type: {
                type: String,
                default: null
            },
            justify: {
                type: String,
                default: 'center'
            },
            lighter: {
                type: Boolean,
                default: false
            },
            limit: {
                type: Number,
                default: 1
            }
        },
        computed: {
            ...mapGetters('flows', [
                'isInputAsset'
            ]),
            hasFirst() {
                return this.count > 0
            },
            hasMore() {
                return this.count > this.limit
            },
            isEmpty() {
                return this.count == 0
            },
            actualLimit() {
                if (isMobileDevice() || isMobileResolution()) return 2
                return this.limit
            },
            label() {
                if (this.type === null) return 'asset'
                return this.type
            },
            count() {
                return this.assets.length
            },
            orderedAssets() {
                return this.assets.sort((a, b) => b.created - a.created)
            },
            visibleAssets() {
                return this.orderedAssets.slice(0, this.actualLimit - 1)
            },
            remainingAssets() {
                return this.orderedAssets.slice(this.actualLimit - 1)
            }
        },
        emits: ['select', 'rate', 'share', 'download', 'delete'],
        methods: {
            handleSelect(asset) {
                this.$emit('select', asset)
            },
            handleRate(asset) {
                this.$emit('rate', asset)
            },
            handleShare(asset) {
                this.$emit('share', asset)
            },
            handleDownload(asset) {
                this.$emit('download', asset)
            },
            handleDelete(asset) {
                this.$emit('delete', asset)
            }
        }
    }
</script>

<style scoped>
    .flow-item-stack {
        max-height: 300px;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
    }

    .flow-item-stack-center {
        flex: unset;
        flex-shrink: 1;
        justify-content: center;
    }

    .flow-item-stack-left {
        justify-content: flex-start;
    }

    .flow-item-stack-right {
        justify-content: flex-end;
    }

    .flow-item-stack-frame {
        width: 10vw;
        height: auto;
        aspect-ratio: 1 / 1;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .flow-item-stack-fill {
        width: 10vw;
        height: auto;
        aspect-ratio: 1 / 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 25px;
        color: rgb(var(--v-theme-secondary));
    }

    @media (max-width: 800px) {
        .flow-item-stack-frame {
            min-width: 25vw;
            max-width: 25vw;
        }

        .flow-item-stack-left {
            justify-content: center;
        }

        .flow-item-stack-right {
            justify-content: center;
        }
    }

    @media (max-width: 600px) {
        .flow-item-stack-frame {
            min-width: 35vw;
            max-width: 35vw;
        }
    }

    @media (max-width: 450px) {
        .flow-item-stack-frame {
            min-width: 45vw;
            max-width: 45vw;
        }
    }
</style>